module.exports = __webpack_public_path__ + "static/painting-63186_640-16d777d7cbdd45c656e43dc66e11254b.jpg";